import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { Button } from "@/components/ui/button";

export const AcessoNegado = ({ area = "esta área" }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-[60vh] flex items-center justify-center fade-up" data-testid="acesso-negado">
      <div className="trt-card p-8 max-w-md text-center space-y-3">
        <ShieldOff className="w-10 h-10 mx-auto text-amber-600" />
        <h1 className="text-xl font-extrabold tracking-tight">Acesso negado</h1>
        <p className="text-sm text-slate-500">Sua função não tem permissão para acessar {area}. Se precisar deste acesso, fale com o administrador da empresa.</p>
        <Button onClick={() => navigate("/dashboard")} className="bg-onyx text-white" data-testid="acesso-negado-voltar">Voltar ao painel</Button>
      </div>
    </div>
  );
};
